import { render } from "./addBankCard.vue?vue&type=template&id=34f897ce&scoped=true"
import script from "./addBankCard.vue?vue&type=script&lang=js"
export * from "./addBankCard.vue?vue&type=script&lang=js"

import "./addBankCard.vue?vue&type=style&index=0&id=34f897ce&scoped=true&lang=css"
import "./addBankCard.vue?vue&type=style&index=1&id=34f897ce&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f897ce"]])

export default __exports__